<script setup lang="ts">
import { computedAsync } from '@vueuse/core';

import { isExperimentAsync } from '@libs/feature-toggle';

const shouldShowCardOverviewSmaller = computedAsync<boolean>(
  () => isExperimentAsync('hotel_card_overview_smaller'),
  false
);
</script>

<template>
  <div
    class="mobile-product-card-layout"
    :class="{ experiment: shouldShowCardOverviewSmaller }"
  >
    <div class="top-section">
      <slot name="top-section" />
      <slot name="top-section-tag" />
    </div>
    <div class="bottom-section">
      <div class="content">
        <slot name="content" />
      </div>
      <div class="footer">
        <slot name="footer" />
      </div>
    </div>
    <slot name="date" />
  </div>
</template>

<style scoped lang="scss">
.mobile-product-card-layout {
  display: grid;
  grid-auto-rows: auto;

  border-radius: var(--border-radius-12);
  border: 1px solid var(--color-neutral-30);
  background-color: var(--color-white);
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
  padding: var(--spacing-12);
  gap: var(--spacing-12);
  &.experiment {
    display: flex;
    flex-direction: column;
    gap: 0;
    .top-section {
      min-height: 153px;
      max-height: 153px;
      margin-bottom: var(--spacing-12);
    }
    .bottom-section {
      height: -webkit-fill-available;
    }
  }
  .top-section {
    width: 100%;
    min-width: 0;
    height: auto;
    border-radius: var(--border-radius-8);
    overflow: hidden;
    position: relative;
  }

  .bottom-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;

    .content {
      border-bottom: unset;
      border-bottom-left-radius: unset;
      flex: 1;
    }

    .footer {
      border: unset;
      border-bottom-left-radius: var(--border-radius-12);
      border-top-right-radius: unset;
    }
  }
}
</style>
